import { render, staticRenderFns } from "./AddVariant.vue?vue&type=template&id=74b51287&scoped=true&"
import script from "./AddVariant.vue?vue&type=script&lang=js&"
export * from "./AddVariant.vue?vue&type=script&lang=js&"
import style0 from "./AddVariant.vue?vue&type=style&index=0&id=74b51287&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b51287",
  null
  
)

export default component.exports